import { useMutation } from "react-query";
import { downloadAgreementsById } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useAgreementForDownload = () => {
  return useMutation(downloadAgreementsById);
};
export default useAgreementForDownload;
